import { apiFetch } from "./client.js";

export interface PatchSettingsBody {
  interestRateAnnualBasisPoints: number;
}

export interface SettingsResponse {
  interestRateAnnualBasisPoints: number;
}

export async function patchSettings(body: PatchSettingsBody): Promise<SettingsResponse> {
  return apiFetch<SettingsResponse>("/api/settings", {
    method: "PATCH",
    body: JSON.stringify(body),
  });
}
